<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" sm="12" xs="12">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col  cols="12" md="3" sm="12" xs="12">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :disabled="!checkdate"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          :disabled="!checkdate"
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('chartservey_label1')" />
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <label>{{$t('chartservey_label2')}} {{totalcnt}}</label>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" sm="6" xs="6">
        <v-simple-table 
          height="40vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-center header_text_style">{{$t('chartservey_col1')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.IDX">
                <template v-if="$i18n.locale == 'ko'">
                  <td class="text-left"><a small @click="loaddetail2(item)">{{ item.TITLE }}</a></td>
                </template>
                <template v-else>
                  <td class="text-left"><a small @click="loaddetail2(item)">{{ item.TITLE_ENG == null || item.TITLE_ENG == undefined || item.TITLE_ENG.length == 0 ? item.TITLE : item.TITLE_ENG }}</a></td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>

      <v-col cols="12" md="6" sm="6" xs="6">
        <v-simple-table 
          height="40vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th style="width:300px;min-width:300px;max-width:300px" class="text-center header_text_style">{{$t('chartservey_col2')}}</th>
                <th style="width:100px" class="text-center header_text_style">{{$t('chartservey_col3')}}</th>
                <th style="width:100px" class="text-center header_text_style">{{$t('chartservey_col4')}}</th>
                <th style="width:100px" class="text-center header_text_style">{{$t('chartservey_col5')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center">{{$t('chartservey_label3')}} {{(rescnt/responsecnt*100).toFixed(1)}} ({{$t('chartservey_label4')}} {{rescnt-responsecnt}})</td>
                <td class="text-center">{{responsecnt}}</td>
                <td class="text-center">{{rescnt}}</td>
                <td class="text-center">{{resrate}}%</td>
              </tr>
              <tr v-for="item in list2" :key="item.FORMAT_OPTION_IDX">
                <template v-if="$i18n.locale == 'ko'">
                  <td class="text-left">{{ item.NAME }}</td>
                </template>
                <template v-else>
                  <td class="text-left">{{ item.NAME_ENG == null || item.NAME_ENG == undefined || item.NAME_ENG.length == 0 ? item.NAME : item.NAME_ENG }}</td>
                </template>
                <td class="text-center">{{ responsecnt }}</td>
                <td class="text-center">{{ priceToString(item.CNT) }}</td>
                <td class="text-center">{{ (item.CNT/responsecnt*100).toFixed(1) }}%</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <canvas ref="drawarea" style="width:95%"/>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
//eslint-disable-next-line no-unused-vars
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment'
import XLSX from 'xlsx'
export default {

  beforeDestroy(){
    //차트 초기화 - 제대로 안지우면 인스턴스 계속 쌓인다.
    if(this.myChart1 != null){
      this.myChart1.destroy();
    }
  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({

      myChart1: null,
      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],

      list2:[],
      totalcnt:0,       //전체 행사의 참가자 수 (VISITOR)
      responsecnt:0,    //질문에 대한 답변자 수 (응답자를 그룹바이 해서 중복 제거함)
      rescnt:0,
      resrate:0,
      fidx:-1,

      loading:false,
      loading2:false,

      PARENT_ITEM: {},
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

  }),

  methods: {
    

    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {

        if(this.list2 == null || this.list2 == undefined || this.list2.length < 1){
          this.$alert(this.$t('chartservey_msg1'));
          return;
        }

        var templist = [];
        this.list2.forEach(item=>{
          templist.push({
            "TITLE":this.$i18n.locale == 'ko' ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG == null || this.PARENT_ITEM.TITLE_ENG == undefined || this.PARENT_ITEM.TITLE_ENG.length == 0 ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG
          , "NAME": this.$i18n.locale == 'ko' ? item.NAME : item.NAME_ENG == null || item.NAME_ENG == undefined || item.NAME_ENG.length == 0 ? item.NAME : item.NAME_ENG 
          , "totalcnt":this.totalcnt
          , "CNT":parseInt(item.CNT)
          , "CNT2":(item.CNT/this.totalcnt*100).toFixed(1)
          });
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t('chartservey_col1')};
        item_sheet.B1 = {v:this.$t('chartservey_col2')};
        item_sheet.C1 = {v:this.$t('chartservey_msg2')};
        item_sheet.D1 = {v:this.$t('chartservey_msg3')};
        item_sheet.E1 = {v:this.$t('chartservey_msg4')};

        //컬럼별 너비
        var wscols = [{wch:30},{wch:30},{wch:10},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('chartservey_msg5'));
        XLSX.writeFile(wb, this.$t('chartservey_msg5')+Date.now().toString()+'.xlsx');

      });

    },        

    initpage(){
      this.search_run();
    },

    dynamicColors : function() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgba(" + r + "," + g + "," + b + ",1)";
    },

    search_run(){

      if(this.grade < 99){
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
      }

      if(this.SEARCH_EVENT_IDX == undefined){
        this.$alert(this.$t("common_select_event"));
        return;
      }

      if(this.checkdate){
        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }
      }

      this.$http.post(this.$host+'/api/ChartSurveyList',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        this.loading = false;

        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            this.totalcnt = 0;
            this.totalcnt = result.data.totalcnt[0].CNT;
            
            if(this.list.length > 0){
              this.loaddetail2(this.list[0]);
            }

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },

    loaddetail2(item){

      if(this.grade < 99){
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
      }

      if(this.SEARCH_EVENT_IDX == undefined){
        this.$alert(this.$t("common_select_event"));
        return;
      }

      if(this.checkdate){
        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }
      }
      
      this.PARENT_ITEM = item;

      if(item.TYPE == 0){
        //주관식
        console.log("type0");
        this.detailType1();
      }else{
        //객관식
        console.log("type1");
        this.detailType2();
      }

    },


    //주관식
    detailType1(){
      this.$http.post(this.$host+'/api/ChartSurveyDetailValue',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , FORMAT_IDX: this.PARENT_ITEM.IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        this.loading2 = false;
        if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.list2.splice(0, this.list2.length);   //데이터 초기화
            this.list2 = result.data.resultData;

            this.responsecnt = 0;
            this.responsecnt = result.data.totalcnt[0].CNT;

            const ctx1 = this.$refs.drawarea;
            if(this.myChart1 != null){
              this.myChart1.destroy();
            }

            const tcnt = this.responsecnt;
            const datas = {labels:[], datasets:[{data:[], backgroundColor:[], borderColor:[]}]};
            const options = {             
                              plugins:{
                                datalabels: {
                                  align:'top',
                                  color: '#ffffff',
                                  backgroundColor: '#00000080',
                                  //차트 기본 표시정보 재정의
                                  formatter:function(value){
                                    var rdata =((parseInt(value)/parseInt(tcnt))*100).toFixed(1);
                                    return value+" ("+rdata+"%)";
                                  },
                                  //0값은 표시 안함
                                  display: function(context) {
                                      return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                                  }
                                },
                                legend: { 
                                    position: 'top' 
                                },
                                title: {
                                    display: true,
                                    text: this.$i18n.locale == 'ko' ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG == null || this.PARENT_ITEM.TITLE_ENG == undefined || this.PARENT_ITEM.TITLE_ENG.length == 0 ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG
                                },         
                                tooltip:{ 
                                  callbacks:{ 
                                    //eslint-disable-next-line no-unused-vars
                                    label:function(context){ 
                                      var value1 = context.formattedValue;
                                      var rdata =((parseInt(value1)/parseInt(tcnt))*100);
                                      return context.label +" " + value1 + " ("+ rdata.toFixed(1)+"%)";
                                    }
                                  }
                                },                                    
                              },
                              responsive: true,
                              maintainAspectRatio: true,
                              aspectRatio : 2
                            };

          this.rescnt = 0;
          this.resrate = 0;
          this.list2.forEach(element => {
            const rcolor = this.dynamicColors();
            datas.labels.push(this.$i18n.locale == 'ko' ? element.NAME : element.NAME_ENG == null || element.NAME_ENG == undefined || element.NAME_ENG.length == 0 ? element.NAME : element.NAME_ENG);
            datas.datasets[0].data.push(element.CNT);
            datas.datasets[0].backgroundColor.push(rcolor);
            datas.datasets[0].borderColor.push(rcolor);
            this.rescnt += element.CNT;
          });
          this.resrate = (this.rescnt/this.responsecnt*100).toFixed(1);

          this.myChart1 = new Chart(ctx1, {type:'pie', data:datas, options: options, plugins:[ChartDataLabels]});
                           
        }
      });


    },


    //객관식
    detailType2(){
      this.$http.post(this.$host+'/api/ChartSurveyDetail',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , FORMAT_IDX: this.PARENT_ITEM.IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        this.loading2 = false;
        if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.list2.splice(0, this.list2.length);   //데이터 초기화
            this.list2 = result.data.resultData;

            this.responsecnt = 0;
            this.responsecnt = result.data.totalcnt[0].CNT;

            const ctx1 = this.$refs.drawarea;
            if(this.myChart1 != null){
              this.myChart1.destroy();
            }

            const tcnt = this.responsecnt;
            const datas = {labels:[], datasets:[{data:[], backgroundColor:[], borderColor:[]}]};
            const options = {             
                              plugins:{
                                datalabels: {
                                  align:'top',
                                  color: '#ffffff',
                                  backgroundColor: '#00000080',
                                  //차트 기본 표시정보 재정의
                                  formatter:function(value){
                                    var rdata =((parseInt(value)/parseInt(tcnt))*100).toFixed(1);
                                    return value+" ("+rdata+"%)";
                                  },
                                  //0값은 표시 안함
                                  display: function(context) {
                                      return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                                  }
                                },
                                legend: { 
                                    position: 'right' 
                                },
                                title: {
                                    display: true,
                                    text: this.$i18n.locale == 'ko' ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG == null || this.PARENT_ITEM.TITLE_ENG == undefined || this.PARENT_ITEM.TITLE_ENG.length == 0 ? this.PARENT_ITEM.TITLE : this.PARENT_ITEM.TITLE_ENG
                                },         
                                tooltip:{ 
                                  callbacks:{ 
                                    //eslint-disable-next-line no-unused-vars
                                    label:function(context){ 
                                      var value1 = context.formattedValue;
                                      var rdata =((parseInt(value1)/parseInt(tcnt))*100);
                                      return context.label +" " + value1 + " ("+ rdata.toFixed(1)+"%)";
                                    }
                                  }
                                },                                    
                              },
                              responsive: true,
                              maintainAspectRatio: true,
                              aspectRatio : 3
                            };

          this.rescnt = 0;
          this.resrate = 0;
          this.list2.forEach(element => {
            const rcolor = this.dynamicColors();
            datas.labels.push(this.$i18n.locale == 'ko' ? element.NAME : element.NAME_ENG == null || element.NAME_ENG == undefined || element.NAME_ENG.length == 0 ? element.NAME : element.NAME_ENG);
            datas.datasets[0].data.push(element.CNT);
            datas.datasets[0].backgroundColor.push(rcolor);
            datas.datasets[0].borderColor.push(rcolor);
            this.rescnt += element.CNT;
          });
          this.resrate = (this.rescnt/this.responsecnt*100).toFixed(1);

          this.myChart1 = new Chart(ctx1, {type:'pie', data:datas, options: options, plugins:[ChartDataLabels]});
                           
        }
      });


    },




    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    //검색조건 업체 설정
    eventsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = "";
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


    .chart-container {
			width: 600px;
			margin-left: 10px;
			margin-right: 10px;
			margin-bottom: 50px;
			border: 1px solid black;
		}

</style>